








































































































































import { Component, Prop, Vue, Inject, Watch } from 'vue-property-decorator';
import * as types from "@/types";
import { AuthenticationResult } from '@azure/msal-browser';

@Component
export default class SoftwareList extends Vue {
	protected softwareItems: types.SoftwareItem[] | null = null;
	protected isLoading: boolean = false;

	protected get isLoggedIn(): boolean {
		return this.$store.getters.isLoggedIn;
	}

	protected async onDownloadClick(softwareId: string, version?: string | undefined): Promise<void> {
		let downloadUrl: string = await this.$auth.getSoftwareDownloadUrl(softwareId, version);
		window.open(downloadUrl, "_self");
	}

	@Watch('isLoggedIn')
	private onLoggedIn(value) {

		if (value)
			this.loadSoftwareItems();
	}

	public async mounted(): Promise<void> {
		this.onLoggedIn(this.isLoggedIn);
	}

	private async loadSoftwareItems(): Promise<void> {
		this.isLoading = true;
		try {
			this.softwareItems = await this.$auth.getSoftware();
		} catch (e) {
			console.dir(e);
		} finally {
			this.isLoading = false;
		}
	}
}

